import { TFunction } from 'i18next'
import { TextColor } from 'particles/Text'

export const getDayLeftDisplay = (
    t: TFunction,
    dayLeft: number | undefined,
    endedTextKey: string,
): { text: string; color: TextColor } => {
    if (typeof dayLeft === 'number' && dayLeft >= 7) {
        // saved day left display
        return { text: t('statusLabel.numberOfDaysLeft', { count: dayLeft }), color: 'primary' }
    } else if (typeof dayLeft === 'number' && dayLeft < 7 && dayLeft > 0) {
        // warning day left display
        return { text: t('statusLabel.lessThanOneWeek'), color: 'warning' }
    } else if (typeof dayLeft === 'number' && dayLeft === 0) {
        // ending day left display
        return { text: t('statusLabel.lessThanOneDay'), color: 'error' }
    } else {
        // ended day left display
        return { text: t(endedTextKey), color: 'primary' }
    }
}
